export const RECIPIENT_KEY_TO = 'to';
export const RECIPIENT_KEY_CC = 'cc';
export const RECIPIENT_KEY_BCC = 'bcc';
export const RECIPIENT_KEY_DEFAULT = 'default';